module.exports = __webpack_public_path__ + "friend3.png?9c07c91b35766a2a6f47c1701fef57db";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend3.png
// module id = 476
// module chunks = 0